import React from "react";

const SolidUserIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='15' cy='15' r='15' fill='#00B38E' />
      <g clipPath='url(#clip0_1928_2819)'>
        <path
          d='M20.7038 21.4167V19.9907C20.7038 19.2344 20.4033 18.509 19.8685 17.9742C19.3337 17.4393 18.6083 17.1389 17.8519 17.1389H12.1482C11.3919 17.1389 10.6665 17.4393 10.1317 17.9742C9.59685 18.509 9.29639 19.2344 9.29639 19.9907V21.4167'
          stroke='white'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15 14.287C16.5751 14.287 17.8519 13.0102 17.8519 11.4352C17.8519 9.86016 16.5751 8.58334 15 8.58334C13.425 8.58334 12.1482 9.86016 12.1482 11.4352C12.1482 13.0102 13.425 14.287 15 14.287Z'
          stroke='white'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1928_2819'>
          <rect
            width='14'
            height='14'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SolidUserIcon;
